import dayjs from "dayjs";

export const formatDate = (date: number | string, showTime = true) => {
  if (showTime) return dayjs(date).format("DD MMM YYYY - HH:mm");
  return dayjs(date).format("DD MMM YYYY");
};
